//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class OCRReceiptDisplayItem extends ItemBase {
    GUID: string | null = null;
    Payee: string | null = null;
    CategoryID: string | null = null;
    Amount: number | null = null;
    Date: string | null = null;
    TaxIDs: string[] = [];
    PaymentMethod: string | null = null;
    Description: string | null = null;
    Filename: string | null = null;
    OriginalOCR: string | null = null;
    OCRProvider: string | null = null;
    Confidence: number = 0;

    constructor(initializer?: Partial<OCRReceiptDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "OCRReceiptDisplayItem";
}
